import React from 'react'
import {Flex, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {remCalc} from '../../../theme/_utils'

const QuantitySwatch = ({enabledVariants}) => {
    const alternativeSwatchValues =
        enabledVariants
            ?.map((variant) => variant?.swatch?.alternativeSwatchValue)
            .filter(Boolean) || []

    return (
        <Flex
            flexDir="row"
            justifyContent="center"
            alignItems="center"
            gap="xxxsmall.base"
            paddingY="xxxsmall-1.base"
            paddingX="xxsmall-1.base"
            alignContent="flex-start"
            flexWrap="nowrap"
            width="fit-content"
        >
            {alternativeSwatchValues.map((value, idx) => {
                const isLast = idx === alternativeSwatchValues.length - 1

                return (
                    <React.Fragment key={`${value}-${idx}`}>
                        <Flex alignItems="center">
                            <Text
                                textStyle="body-xsmall"
                                fontWeight="medium"
                                color="foreground.neutral.default"
                            >
                                {value}
                            </Text>
                        </Flex>
                        {!isLast ? (
                            <Flex
                                aria-hidden="true"
                                height={remCalc(8)}
                                borderRight="small"
                                borderRightStyle="solid"
                                borderColor="black"
                            />
                        ) : null}
                    </React.Fragment>
                )
            })}
        </Flex>
    )
}

QuantitySwatch.propTypes = {
    enabledVariants: PropTypes.array,
}

export default QuantitySwatch
